import TypeCaracteristiquesDetailController from './type.caracteristiques.detail.controller';

export default {
    template: require('./type.caracteristiques.detail.tpl.html'),
    controller: TypeCaracteristiquesDetailController,
    bindings: {
        caracteristiques: '<'
    }
};
